import { Component, OnInit } from '@angular/core';
import { LoginService } from '../service/login.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from "@angular/router";
import { PerfilService } from '../service/perfil.service';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  session: any
  default = true;
  recuperar = false;
  nuevo = false;
  mensaje = false;
  title = "Bienvenido";
  subTitle = "Inicia sesión para continuar";
  button = "Iniciar sesión";
  json: any;
  dpi: any = "";
  nombre: string;
  apePaterno: string;
  apeMaterno: string;
  apeCasada: string;
  sexo = 'M';
  fecNacimiento: string;
  nacionalidad: string;
  direccion: string;
  email: string;
  REemail: string;
  tel: string;
  passReset = false;
  fechaAux = new Date();

  validaCorreo: boolean = false;
  mensajeValidacion: boolean = false;

  password: string;
  password2: string
  tipo: number;
  response: any;
  errorMensaje: any;
  hostname: string
  ip: any;
  token: any;
  tokenValida: any;
  bloqueo = 0;
  version = '1.0.18'
  loading = false;

  formLogin = new FormGroup({
    dpi: new FormControl(),
    pass: new FormControl()
  })

  constructor(private login: LoginService, private route: Router, private perfil: PerfilService,
    private http: HttpClient, private rout: ActivatedRoute) {
    localStorage.clear()
    this.login.currentSession.subscribe(login => this.session = login);
    this.rout.queryParams.subscribe(params => {
      this.token = params['token'];
      this.tokenValida = params['tokenValidacion'];
      if (this.token) {
        this.change(5);
      }

      if (this.tokenValida) {
        this.change(6);
      }
    });
  }

  ngOnInit() {
    this.tipo = 1;
    this.ip = { ip: '127.0.0.1' }
    this.dpi = "",
      this.nombre = "",
      this.apePaterno = "",
      this.apeMaterno = "",
      this.apeCasada = "",
      this.password = "",
      this.sexo = "",
      this.email = "",
      this.fecNacimiento = "",
      this.nacionalidad = "",
      this.direccion = "",
      this.tel = ""


  }

  send(tipo: number) {
    this.errorMensaje = "";
    this.loading = true;
    /*     this.dpi = this.formLogin.controls['dpi'].value
        this.password = this.formLogin.controls['pass'].value */
    switch (tipo) {
      case 1:
        this.json = {
          dni: this.dpi,
          password: this.password,
          nomHost: this.ip.ip || '127.0.0.1'
        }
        if (this.dpi == "") {
          this.errorMensaje = "Ingrese los datos Solicitados";
          this.loading = false
          return
        }

        if (this.password == "") {
          this.errorMensaje = "Ingrese los datos Solicitados";
          this.loading = false
          return
        }

        let json = {
          dni: this.dpi,
          appUrl: window.location.origin + '/Pocae'
        }

        this.login.validaCorreo(json).subscribe(res => {
          this.response = res
          if (this.response.numError != 0) {
            this.loading = false;
            this.errorMensaje = this.response.msjError;
          } else {
            this.login.iniciar(this.json).subscribe(res => {
              this.response = res;

              if (this.response.numError != 0) {
                this.loading = false;
                this.errorMensaje = this.response.msjError
              } else {
                let name = `${this.response.sesion.nombres, this.response.sesion.apePat, this.response.sesion.apeMat}`
                let body = {
                  ksi: this.response.sesion.idSesion,
                  name: name,
                  idUsuario: this.response.sesion.idUsuarioWeb,
                  bloqueos: this.response.bloqueos,
                  dpi: this.dpi
                }
                localStorage.setItem('KSI',this.response.sesion.idSesion )
                localStorage.setItem('sesionPocae', JSON.stringify(body))
                this.login.addSession(this.response.sesion.idSesion, this.response.sesion.name, this.ip.ip, this.response.sesion.idUsuarioWeb, this.response.bloqueos);
                this.perfil.addCards(this.dpi);
                this.perfil.addCurrentUser(this.response.sesion.nombres, this.response.sesion.apePat, this.response.sesion.apeMat)
                this.route.navigate(['/pocae/resumen'])
              }
            }, () => {
              this.loading = false;
              this.errorMensaje = "Error. Intente más tarde.";
            })
          }
        }, () => {
          this.loading = false;
          this.errorMensaje = "Error. Intente más tarde.";
        })

        break;
      case 2:

        this.json = {
          dni: this.dpi,
          nombres: this.nombre,
          apePaterno: this.apePaterno,
          apeMaterno: this.apeMaterno,
          apeCasada: '',
          passActual: this.password,
          sexo: this.sexo,
          correo: this.email,
          fecNacimiento: this.fecNacimiento,
          nacionalidad: this.nacionalidad,
          direccion: this.direccion,
          telefono: this.tel
        }

        if (!this.comproboPass()) {

          this.errorMensaje = "Las Contraseñas no Coinciden";
          this.loading = false;
          return
        }



        if (!this.comproboField()) {

          this.errorMensaje = "Completa todos los campos";
          this.loading = false;
          return
        }


        if (!this.comproboEmail()) {
          this.errorMensaje = "Mail inválido"
          this.loading = false
          return
        }

        if (!this.comprobReEmail()) {
          this.errorMensaje = "Ambos email deben ser iguales";
          this.loading = false
          return
        }

        if (this.comproboDate()) {
          this.errorMensaje = "Fecha inválida"
          this.loading = false
          return
        }
        if (this.password.length < 6) {
          this.errorMensaje = "Contraseña debe tener mínimo 6 caracteres"
          this.loading = false
          return
        }



        this.perfil.addUser(this.json).subscribe(res => {
          this.response = res;
          if (this.response.numError != 0) {
            this.loading = false;
            this.errorMensaje = this.response.msjError;
          } else {
            this.loading = false
            this.change(4)
          }

        })
        break;
      case 3:
        this.json = {
          correo: this.email,
          appUrl: window.location.origin + '/Pocae'
        }
        if (!this.comproboEmail()) {
          this.errorMensaje = "Mail inválido"
          this.loading = false
        } else {
          this.login.recuperar(this.json).subscribe(res => {
            this.response = res
            if (this.response.numError != 0) {
              this.loading = false;
              this.errorMensaje = this.response.msjError;
            } else {
              this.loading = false;
              this.change(4);
            }
          }, () => {
            this.loading = false;
            this.errorMensaje = "Error. Intente más tarde.";
          })
        }
        break;
      case 4:
        if (this.dpi.trim() == "" || this.dpi == undefined) {
          this.errorMensaje = "Ingrese DNI.";
          this.loading = false;
        } else {
          this.errorMensaje = null;
          let json = {
            dni: this.dpi,
            tokenValidaCorreo: this.tokenValida
          }

          this.login.actualizaIndValido(json).subscribe(res => {
            this.response = res;
            if (this.response.numError != 0) {
              if (this.response.numError === 100) {
                this.loading = false;
                this.errorMensaje = 'Usuario ya se encuentra validado';
              }
              else if (this.response.numError === 200) {
                this.loading = false;
                this.errorMensaje = 'Los Token no coinciden';
              }
              else {
                this.loading = false;
                this.errorMensaje = this.response.msjError;
              }
            } else {
              window.history.pushState({}, document.title, window.location.origin + "/#/"); //limpia la url del token
              this.loading = false
              this.change(7)
            }
          }, () => {
            this.loading = false;
            this.errorMensaje = "Error. Intente más tarde.";
          })
        }

        break;
    }
  }
  clearData() {
    this.dpi = '';
    this.password = '';
    this.nombre = '';
    this.apePaterno = '';
    this.apeMaterno = '';
    this.apeCasada = '';
    this.password2 = '';
    this.sexo = '';
    this.email = '';
    this.fecNacimiento = '';
    this.nacionalidad = '';
    this.direccion = '';
    this.tel = '';
  }

  change(tipo) {
    this.clearData()
    this.errorMensaje = ""

    switch (tipo) {
      case 1:
        this.mensaje = false;
        this.default = true;
        this.recuperar = false;
        this.passReset = false;
        this.nuevo = false;
        this.validaCorreo = false;
        this.mensajeValidacion = false;
        this.title = "Bienvenido";
        this.subTitle = "Inicia sesión para continuar";
        this.button = "Iniciar sesión";
        this.tipo = 1;
        break;

      case 2:
        this.default = false;
        this.recuperar = false;
        this.nuevo = true;
        this.passReset = false;
        this.validaCorreo = false;
        this.title = "Para Comenzar";
        this.subTitle = "Crea una cuenta";
        this.button = "Crear cuenta";
        this.tipo = 2
        break;

      case 3:
        this.default = false;
        this.recuperar = true;
        this.nuevo = false;
        this.passReset = false;
        this.validaCorreo = false;
        this.title = "Recuperar cuenta";
        this.subTitle = "Intentemos recuperar el acceso a tu cuenta";
        this.button = "Enviarme código de recuperación";
        this.tipo = 3;
        break;

      case 4:
        this.mensaje = true;
        break;

      case 5:
        this.default = false;
        this.recuperar = false;
        this.nuevo = false;
        this.passReset = true;
        this.validaCorreo = false;
        this.title = "Cambiar Contraseña";
        this.subTitle = "";
        this.button = "Cambiar";
        break;

      case 6:
        this.default = false;
        this.recuperar = false;
        this.nuevo = false;
        this.passReset = false;
        this.validaCorreo = true;
        this.title = "Validar Correo";
        this.subTitle = "";
        this.button = "Validar";
        this.tipo = 4;
        break;

      case 7:
        this.mensajeValidacion = true;
        break;
    }
  }

  onlyNumber($event) {
    let key = $event.charCode;

    if (key <= 57 && key >= 48) {
      return true;

    } else {
      return false

    }
  }

  onlyLetter(event) {
    const pattern = /[^a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ' ]/g
    event.target.value = event.target.value.replace(pattern, '');
  }

  onlyLetterWhitoutSpace(event) {
    const pattern = /[^a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ']/g
    event.target.value = event.target.value.replace(pattern, '');
  }

  comproboPass() {
    return this.password == this.password2
  }
  comproboField() {
    return (this.dpi == "" || this.nombre == "" || this.apePaterno == "" || this.password == "" || this.sexo == "" || this.email == "" || this.fecNacimiento == "" || this.nacionalidad == "" || this.direccion == "" || this.tel == "") ? false : true;
  }

  comproboEmail() {
    let mailValido = false;
    var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.email.match(EMAIL_REGEX)) {
      mailValido = true;
    }
    return mailValido;
  }

  comproboDate() {
    var fecha = new Date(this.fecNacimiento)
    var today = new Date();
    today.setHours(0, 0, 0, 0)

    return (fecha >= today)
  }

  resetPassword() {
    if (this.password.length > 0 && this.password2.length > 0) {
      if (this.comproboPass()) {
        if (this.password.length < 6) {
          this.errorMensaje = "Contraseña debe tener mínimo 6 caracteres"
        } else {

          this.json = {
            tokenRecuperaPass: this.token,
            passNueva: this.password
          }

          this.login.resetPass(this.json).subscribe(res => {
            this.response = res
            if (this.response.numError != 0) {
              this.errorMensaje = this.response.msjError;
            } else {
              window.history.pushState({}, document.title, window.location.origin + "/#/"); //limpia la url del token
              this.change(4);
            }
          })
        }
      }
      else {
        this.errorMensaje = 'Las contraseñas deben ser iguales.'
      }
    }
    else {
      this.errorMensaje = 'Debe completar todos los campos.'
    }
  }


  comprobReEmail() {

    return this.email === this.REemail
  }
  addSession(idSession: string, nombre: string, hostName: string, usuarioWeb: string, bloqueos: any) {
    this.login.addSession(idSession, nombre, hostName, usuarioWeb, bloqueos);
  }
}
